import React, { Component, PureComponent, Fragment } from 'react'
import { htmlEncode, htmlDecode } from 'js-htmlencode'
import { Modal } from 'semantic-ui-react'

export function generateWidgetCode(businessid) {
  return `<script>(function(d, s, id) {
var js, fjs = d.getElementsByTagName(s)[0];
if (d.getElementById(id)) return;
js = d.createElement(s); 
js.id = id; 
js.async = true;
js.src = "//www.kokemuksia.fi/embed-feed.js";
fjs.parentNode.insertBefore(js, fjs);
}(document, 'script', 'kokemuksia-widget'));</script>

<div data-kokemuksia-embed-feed 
  data-company="${businessid.toLowerCase().replace('fi-', '')}" 
  data-items="4" 
  data-title="Kokemuksia meistä"
  data-type="" 
  data-random></div>`
}

export function generateWidgetCodeForEmail(businessid) {
  let code = generateWidgetCode(businessid)
  return `<pre>${htmlEncode(code)}</pre>`
}

class WidgetPreview extends Component {
  render() {
    let { script } = this.props

    let content = `
      <html><body>${script}</body></html>
      `

    return (
      <iframe
        ref={el => (this._frame = el)}
        srcDoc={content}
        style={{ width: '100%', border: 'none', height: '600px' }}
      />
    )
  }
}

export default class WidgetCode extends Component {
  state = {
    preview: false,
  }

  render() {
    let { businessId = false } = this.props

    if (!businessId) return <div className="widget-code">Y-tunnus tarvitaan Widgetin käyttöön.</div>

    let { preview } = this.state

    let widget = generateWidgetCode(businessId)

    return (
      <div className="widget-code-wrapper">
        <div className="widget-code">
          <pre>
            <code>{widget}</code>
          </pre>
        </div>
        <div className="widget-code-preview">
          <Modal
            trigger={
              <button className="button-plain" onClick={e => e.preventDefault() & this.setState({ preview: true })}>
                Näytä esikatselu
              </button>
            }
            open={preview}
            onClose={() => this.setState({ preview: false })}>
            <Modal.Header>
              <button className="button-plain" onClick={e => e.preventDefault() & this.setState({ preview: false })}>
                Sulje
              </button>
            </Modal.Header>
            <Modal.Content>{preview ? <WidgetPreview script={widget} /> : null}</Modal.Content>
          </Modal>
          <span> </span>
          <a
            href={`https://kokemuksia-widget.bebob.site/?ytunnus=${businessId.toLowerCase().replace('fi-', '')}`}
            className="button-plain"
            target="_blank">
            Avaa esikatselusivu
          </a>
        </div>
      </div>
    )
  }
}
